/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recover_SuccessInputs */



/**
* | output |
* | --- |
* | "If an account with that email exists, we've sent a login link." |
*
* @param {Auth_Recover_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recover_success = /** @type {((inputs?: Auth_Recover_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recover_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wenn es ein Konto mit dieser E-Mail-Adresse gibt, haben wir einen Anmeldelink gesendet.")
	return /** @type {LocalizedString} */ ("If an account with that email exists, we've sent a login link.")
});